import axios from 'axios'
import db from '@/utils/localstorage'
import Setting from '@/setting';
import { Toast } from 'vant';

// 创建一个 axios 实例
const service = axios.create({
    baseURL: Setting.apiBaseURL
});

// 请求拦截器
service.interceptors.request.use(
    config => {
        // 在请求发送之前做一些处理
        const token = db.get('token');
        // 让每个请求携带token-- ['X-Token']为自定义key 请根据实际情况自行修改
        config.headers.Authentication = token;
        return config;
    },
    error => {
        // 发送失败
        console.log(error);
        Promise.reject(error);
    }
);

// 响应拦截器
service.interceptors.response.use(
    response => {
        return response;
    },
    error => {
        if (error && error.response) {
            switch (error.response.status) {
            case 400: error.message = '请求错误'; break;
            case 401: error.message = '未授权，请登录'; this.$router.push({ name: 'login' }); break;
            case 403: error.message = '拒绝访问'; break;
            case 404: error.message = `请求地址出错: ${error.response.config.url}`; break;
            case 408: error.message = '请求超时'; break;
            case 500: error.message = `${error.response.data.message}`; break;
            case 501: error.message = '服务未实现'; break;
            case 502: error.message = '网关错误'; break;
            case 503: error.message = '服务不可用'; break;
            case 504: error.message = '网关超时'; break;
            case 505: error.message = 'HTTP版本不受支持'; break;
            default: break;
            }
        }
        return Promise.reject(error.response.data);
    }
);

const request = {
    post (url, params, header) {
        // Toast.loading({message:'处理中...'})
        return service.post(Setting.apiBaseURL + url, params, {
            transformRequest: [(params) => {
                if (header && header.contentType) {
                    return params
                }
                let result = ''
                Object.keys(params).forEach((key) => {
                    if (!Object.is(params[key], undefined) && !Object.is(params[key], null)) {
                        result += encodeURIComponent(key) + '=' + encodeURIComponent(params[key]) + '&'
                    }
                })
                return result
            }],
            headers: {
                'Content-Type': (header && header.contentType) || 'application/x-www-form-urlencoded'
            }
        }
        )
    },
    get (url, params) {
        let _params
        if (Object.is(params, undefined)) {
            _params = ''
        } else {
            _params = '?'
            for (const key in params) {
                if (params.prototype.hasOwnProperty.call(key) && params[key] !== null) {
                    _params += `${key}=${params[key]}&`
                }
            }
        }

        return service.get(`${Setting.apiBaseURL}${url}${_params}`)
    },
    put (url, params, header) {
        return service.put(url, params, {
            transformRequest: [(params) => {
                if (header && header.contentType) {
                    return params
                }
                let result = ''
                Object.keys(params).forEach((key) => {
                    if (!Object.is(params[key], undefined) && !Object.is(params[key], null)) {
                        result += encodeURIComponent(key) + '=' + encodeURIComponent(params[key]) + '&'
                    }
                })
                return result
            }],
            headers: {
                'Content-Type': (header && header.contentType) || 'application/x-www-form-urlencoded'
            }
        })
    },
    delete (url, params) {
        let _params
        if (Object.is(params, undefined)) {
            _params = ''
        } else {
            _params = '?'
            for (const key in params) {
                if (params.prototype.hasOwnProperty.call(key) && params[key] !== null) {
                    _params += `${key}=${params[key]}&`
                }
            }
        }
        return service.delete(`${url}${_params}`)
    },
    export (url, params = {},fileName) {
        Toast.loading({ message: '导出数据中' })
        return service.post(url, params, {
            transformRequest: [(params) => {
                let result = ''
                Object.keys(params).forEach((key) => {
                    if (!Object.is(params[key], undefined) && !Object.is(params[key], null)) {
                        result += encodeURIComponent(key) + '=' + encodeURIComponent(params[key]) + '&'
                    }
                })
                return result
            }],
            responseType: 'blob'
        }).then((r) => {
            const content = r.data
            const blob = new Blob([content])
            const isWechat = /MicroMessenger/i.test(navigator.userAgent);
            const isMobile = /Android|iPhone|iPad/i.test(navigator.userAgent);
            if (isMobile || isWechat){
              if ('download' in document.createElement('a')) {
                const elink = document.createElement('a')
                elink.download = fileName
                elink.style.display = 'none'
                elink.href = URL.createObjectURL(blob)
                document.body.appendChild(elink)
                elink.click()
                URL.revokeObjectURL(elink.href)
                document.body.removeChild(elink)
              } else {
                navigator.msSaveBlob(blob, fileName)
              }
            } else {
              const urlLocal = URL.createObjectURL(r.data);
              window.location.href = urlLocal;
              URL.revokeObjectURL(urlLocal);
            }
        }).catch((r) => {
            console.error(r)
            Toast.fail('导出失败')
        })
    },
    download (url, params, filename) {
        Toast.loading({ message: '文件传输中' })
        return service.post(url, params, {
            transformRequest: [(params) => {
                let result = ''
                Object.keys(params).forEach((key) => {
                    if (!Object.is(params[key], undefined) && !Object.is(params[key], null)) {
                        result += encodeURIComponent(key) + '=' + encodeURIComponent(params[key]) + '&'
                    }
                })
                return result
            }],
            responseType: 'blob'
        }).then((r) => {
            const content = r.data
            const blob = new Blob([content])
            if ('download' in document.createElement('a')) {
                const elink = document.createElement('a')
                elink.download = filename
                elink.style.display = 'none'
                elink.href = URL.createObjectURL(blob)
                document.body.appendChild(elink)
                elink.click()
                URL.revokeObjectURL(elink.href)
                document.body.removeChild(elink)
            } else {
                navigator.msSaveBlob(blob, filename)
            }
        }).catch((r) => {
            console.error(r)
            Toast.fail('下载失败')
        })
    },
    upload (url, params) {
        return service.post(url, params, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
    }
};
export default request;
